var render = function render(_c,_vm){return _c('div',{staticClass:"b2b-card__actions",class:{
    ..._vm.data.staticClass,
    'b2b-card__actions--centered': _vm.props.centered,
    'b2b-card__actions--justify-center': _vm.props.justifyCenter,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }